import React from "react";
import { useTranslation } from "react-i18next";

//Style
import "./InfoAboutUsSection.css";

//Data
import dataInfoWAWFH from "../../json/infoAboutUs/infoWAWFH.json";
import dataInfoWAWSH from "../../json/infoAboutUs/infoWAWSH.json";

const InfoAboutUsSection = () => {
  const { t } = useTranslation();

  return (
    <section className="waw-section">
      <div className="half-section-container first">
        <div className="waw-title-container">
          <span className="deco-title" />
          <h1>{t("about_us_page.info_section_1.title")}</h1>
        </div>
        <div className="info-first-half-container">
          <div className="info-fh-elm-container">
            <div className="num-container">
              <img
                className="num-icon"
                src={dataInfoWAWFH.data[0].number}
                alt=""
              />
            </div>
            <div className="text-info-elm-container">
              <div className="title-fh-elm-container">
                <h2>{t(dataInfoWAWFH.data[0].title)}</h2>
                <img
                  className="title-icon"
                  src={dataInfoWAWFH.data[0].icon}
                  alt=""
                />
              </div>
              <div className="desc-info-container">
                {t(dataInfoWAWFH.data[0].content)}
              </div>
            </div>
          </div>
          <div className="info-fh-elm-container">
            <div className="num-container">
              <img
                className="num-icon"
                src={dataInfoWAWFH.data[1].number}
                alt=""
              />
            </div>
            <div className="text-info-elm-container">
              <div className="title-fh-elm-container">
                <h2>{t(dataInfoWAWFH.data[1].title)}</h2>
                <img
                  className="title-icon"
                  src={dataInfoWAWFH.data[1].icon}
                  alt=""
                />
              </div>
              <div className="desc-info-container">
                {t(dataInfoWAWFH.data[1].content)}
              </div>
            </div>
          </div>
          <div className="info-fh-elm-container">
            <div className="num-container">
              <img
                className="num-icon"
                src={dataInfoWAWFH.data[2].number}
                alt=""
              />
            </div>
            <div className="text-info-elm-container">
              <div className="title-fh-elm-container">
                <h2>{t(dataInfoWAWFH.data[2].title)}</h2>
                <img
                  className="title-icon"
                  src={dataInfoWAWFH.data[2].icon}
                  alt=""
                />
              </div>
              <div className="desc-info-container">
                {t(dataInfoWAWFH.data[2].content)}
              </div>
            </div>
          </div>
        </div>
        <div className="info-first-half-container">
          <div className="info-fh-elm-container">
            <div className="num-container">
              <img
                className="num-icon"
                src={dataInfoWAWFH.data[3].number}
                alt=""
              />
            </div>
            <div className="text-info-elm-container">
              <div className="title-fh-elm-container">
                <h2>{t(dataInfoWAWFH.data[3].title)}</h2>
                <img
                  className="title-icon"
                  src={dataInfoWAWFH.data[3].icon}
                  alt=""
                />
              </div>
              <div className="desc-info-container">
                {t(dataInfoWAWFH.data[3].content)}
              </div>
            </div>
          </div>
          <div className="info-fh-elm-container">
            <div className="num-container">
              <img
                className="num-icon"
                src={dataInfoWAWFH.data[4].number}
                alt=""
              />
            </div>
            <div className="text-info-elm-container">
              <div className="title-fh-elm-container">
                <h2>{t(dataInfoWAWFH.data[4].title)}</h2>
                <img
                  className="title-icon"
                  src={dataInfoWAWFH.data[4].icon}
                  alt=""
                />
              </div>
              <div className="desc-info-container">
                {t(dataInfoWAWFH.data[4].content)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="half-section-container second">
        <div className="waw-title-container second-waw-title">
          <span className="deco-title deco-oposite" />
          <h1>{t("about_us_page.info_section_2.title")}</h1>
        </div>
        <div className="waw-sh-info-container">
          <div className="subtitle-waw-sh">
            {t(
              "about_us_page.info_section_2.info_topic_elms.info_topic_desc_1"
            )}
          </div>
          <div className="info-second-half-container">
            {dataInfoWAWSH.data.map((infoSH, i) => {
              return (
                <div key={i} className="info-sh-subcontainer">
                  <img className="info-sh-icon" src={infoSH.srcImg} alt="" />
                  <div>{t(infoSH.info)}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoAboutUsSection;
